import { useCallback } from "react";
import { Link } from "react-router-dom";
import { shiftApi } from "../../../api/resources";
import type { ShiftAdmin } from "../../../api/types";
import { DataTable, LoadState, useLoad } from "../shared";
import { AttentionIcon, ShiftStatusPill, fmtWorkDate, timeRange } from "../shifts/shiftUi";

export function EmployeeAssignments({ employeeId }: { employeeId: string }) {
  const loader = useCallback(() => shiftApi.list({ employee_id: employeeId, scope: "upcoming" }), [employeeId]);
  const { data, error } = useLoad<ShiftAdmin[]>(loader);
  return (
    <section data-testid="employee-assignments" className="mt-8">
      <div className="mb-4 flex items-end justify-between">
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">Upcoming assignments</h2>
        <Link to="/admin/shift-assignments" data-testid="employee-assignments-all-link" className="text-xs text-signal hover:text-white">All shifts</Link>
      </div>
      <LoadState error={error} loading={!data && !error} testId="employee-assignments-error" />
      {data && (
        <DataTable testId="employee-assignments-table" headers={["Date", "Time (venue local)", "Venue", "Role", "Status", ""]} empty={data.length === 0}>
          {data.map((s) => (
            <tr key={s.id} data-testid={`employee-assignment-row-${s.id}`} className="hover:bg-white/[0.03]">
              <td className="whitespace-nowrap px-5 py-3">
                <Link to={`/admin/shift-assignments?shift=${s.id}`} data-testid={`employee-assignment-link-${s.id}`} className="text-white hover:text-signal">{fmtWorkDate(s.work_date)}</Link>
              </td>
              <td className="whitespace-nowrap px-5 py-3 text-zinc-300">{timeRange(s)}</td>
              <td className="px-5 py-3 text-zinc-300">{s.venue_name}</td>
              <td className="px-5 py-3 text-zinc-400">{s.role ?? "—"}</td>
              <td className="px-5 py-3"><ShiftStatusPill status={s.status} testId={`employee-assignment-status-${s.id}`} /></td>
              <td className="px-5 py-3"><AttentionIcon show={s.needs_attention} testId={`employee-assignment-flag-${s.id}`} /></td>
            </tr>
          ))}
        </DataTable>
      )}
    </section>
  );
}
